import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Icon, FileThumbnail } from '@febos-io/design';

const formikInputFileDropZoneThumb = {
  display: 'block',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  marginBottom: 8,
  marginRight: 8,
  height: 100,
  minWidth: 100,
  padding: 4,
  boxSizing: 'border-box',
};

const thumbInner = {
  display: 'contents',
  minWidth: 100,
  minHeight: 100,
  overflow: 'hidden',
  textAlign: 'center',
};

const thumbInnerRemove = {
  position: 'absolute',
  float: 'right',
};

const thumbInnerPercent = {
  display: 'block',
  width: '100%',
};

const img = {
  display: 'block',
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
};

export function FormikInputFileDropZoneThumb({
  file,
  hideDelete,
  onRemove = () => {
    return false;
  },
}) {
  useEffect(() => {
    return () => {
      URL.revokeObjectURL(file.preview);
    };
  }, [file.preview]);

  return (
    <div style={formikInputFileDropZoneThumb} key={file.name}>
      {(!hideDelete && onRemove)
      && (
      <span style={thumbInnerRemove}>
        <Icon onClick={() => onRemove(file)} icon="fa-close" className="btn-fb btn-sm btn-danger" />
      </span>
      )
      }
      {((file.preview || file.type.indexOf('image') >= 0) && (file.previewSigned || file.fileKeySigned || file.preview)) ? (
        <div style={thumbInner} title={file.name}>
          <img
            src={file.previewSigned || file.preview || file.fileKeySigned}
            style={img}
            alt={file.name}
          />
        </div>
      ) : (
        <div style={thumbInner} title={file.name}>
          <FileThumbnail
            name={file.name}
            alt={file.name}
          />
        </div>
      )}
      {file.meta && file.meta.progress < 100 && (
        <div className="progress" style={thumbInnerPercent}>
          <div
            className={classNames('progress-bar progress-bar-striped progress-bar-animated', {
              'bg-secondary': !file.meta.progress || file.meta.progress === 100,
            })}
            role="progressbar"
            aria-valuenow={file.meta.progress}
            aria-valuemin="0"
            aria-valuemax="100"
            style={{
              width: `${file.meta.progress || 100}%`,
            }}
          >
            {file.meta.progress && `${file.meta.progress} %`}
          </div>
        </div>
      )}
    </div>
  );
}

FormikInputFileDropZoneThumb.propTypes = {
  file: PropTypes.object.isRequired,
  hideDelete: PropTypes.bool,
  onRemove: PropTypes.func,
};

export default FormikInputFileDropZoneThumb;
